import ContactDetails from './ContactDetails'; 

export default ContactDetails;